import apiRequest from "../../helpers/apiRequest";

export default async (slug) => {
    return await apiRequest({
        method: 'get',
        url: `content/group/session`,
    })
}
